import HomePage from "./home";
import ContactPage from "./contact";
import AboutPage from "./about";
import Create from "./create";
import Accelerate from "./accelerate";
import Article1 from "./article1";
import Article2 from "./article2";

export const CLIENT_ROUTES = [
  {
    Component: HomePage,
    path: "/",
  },
  {
    Component: HomePage,
    path: "/s/:key",
  },
  {
    Component: Create,
    path: "/program-bekup-create",
  },
  {
    Component: Accelerate,
    path: "/program-bekup-accelerate",
  },
  {
    Component: AboutPage,
    path: "/about",
  },
  {
    Component: Article1,
    path: "/article1",
  },
  {
    Component: Article2,
    path: "/article2",
  },
  {
    Component: ContactPage,
    path: "/contact",
  },
  {
    Component: HomePage,
    path: "/*",
  },
];
